import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export function useProfile() {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function init() {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) { setLoading(false); return }

      let { data } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single()

      // Seed from localStorage if profile was collected at signup
      if (!data) {
        const pending = localStorage.getItem('florece-pending-profile')
        if (pending) {
          try {
            const { nombre, genero, fechaNac } = JSON.parse(pending)
            const { data: created } = await supabase
              .from('profiles')
              .upsert({ id: user.id, nombre: nombre || null, genero: genero || 'otro', fecha_nacimiento: fechaNac || null })
              .select()
              .single()
            data = created
            localStorage.removeItem('florece-pending-profile')
          } catch (_) {}
        }
      }

      setProfile(data)
      setLoading(false)
    }
    init()
  }, [])

  async function updateProfile(cambios) {
    const { data: { user } } = await supabase.auth.getUser()
    const { data, error } = await supabase
      .from('profiles')
      .upsert({ id: user.id, ...cambios })
      .select()
      .single()
    if (!error) setProfile(data)
    return { data, error }
  }

  async function deleteAccount() {
    const { error } = await supabase.rpc('delete_user')
    return { error }
  }

  return { profile, loading, updateProfile, deleteAccount }
}
